var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.envelopes),function(envelope,index){return _c('envelope-slip',{key:index,staticClass:"envelope-slip",attrs:{"envelope":envelope}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }